export default __webpack_public_path__ + "static/media/pexels-daniel-reche-3601094.4631bec2.jpg";